export default "__VITE_ASSET__651f39a0__"